import React from "react";

/**
 * Shown to members of an institute that has paid but is still awaiting
 * site-admin approval. Nobody in the institute (admin included) can use the
 * app until it's approved — the backend keeps has_access false while the
 * institute status is "pending".
 */
function InstitutePendingScreen({ user, onLogout }) {
  const isInstituteAdmin = user?.institute?.role === "admin";

  return (
    <div className="dark-scope relative min-h-screen flex items-center justify-center px-4 py-10 overflow-hidden" style={{ background: "var(--ink)" }}>
      <div className="pointer-events-none absolute -top-24 -right-24 w-96 h-96 rounded-full bg-ink-100/50 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-28 -left-24 w-96 h-96 rounded-full bg-gold-100/40 blur-3xl" />
      <div className="relative z-10 w-full max-w-sm animate-rise">
        <div className="text-center mb-7">
          <span className="text-6xl font-arabic-display text-ink-600 leading-none" dir="rtl">مراجعة</span>
          <div className="rule-ornament w-40 mx-auto mt-3"><span className="text-gold-400">✦</span></div>
        </div>
        <div className="bg-parchment-50 rounded-2xl shadow-soft-lg border border-parchment-300/70 p-8 text-center">
          <div className="text-4xl mb-3">🕐</div>
          <h2 className="text-2xl font-display font-semibold text-ink-800 mb-2">
            {user?.institute?.name || "Your institute"} is being reviewed
          </h2>
          <p className="text-sm text-slate-500 mb-6">
            {isInstituteAdmin
              ? "Thanks for registering! Your payment went through and your institute is awaiting approval. We'll email you as soon as it's activated — then you can add your students and teachers."
              : "Your institute's account is awaiting approval. Please check back soon, or ask your institute administrator for details."}
          </p>
          <button
            onClick={onLogout}
            className="mt-1 w-full py-2 text-slate-400 hover:text-slate-600 text-sm transition-colors"
          >
            Log out
          </button>
        </div>
      </div>
    </div>
  );
}

export default InstitutePendingScreen;
